var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _circle, _path10, _path11, _rect3, _rect4, _rect5, _rect6, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 54,
    fill: "#F6F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4864 80.4663C86.4864 82.5907 85.6246 84.5131 84.2325 85.9052C82.8404 87.2973 80.918 88.1591 78.7936 88.1591H42.9456C45.07 88.1591 46.9924 87.2973 48.3845 85.9052C49.7766 84.5131 50.6384 82.5907 50.6384 80.4663C50.6384 76.2174 47.1945 72.7734 42.9456 72.7734H78.7936C83.0425 72.7734 86.4864 76.2174 86.4864 80.4663Z",
    fill: "#E2E4E9",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2598 70.5063C56.6519 71.8984 58.5744 72.7602 60.6988 72.7602H24.8515C22.7271 72.7602 20.8047 71.8984 19.4126 70.5063C18.0205 69.1142 17.1587 67.1918 17.1587 65.0674C17.1587 60.8185 20.6026 57.3745 24.8515 57.3745H60.6988C56.4499 57.3745 53.006 60.8185 53.006 65.0674C53.006 67.1918 53.8678 69.1142 55.2598 70.5063Z",
    fill: "#E2E4E9",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6624 80.3271V80.6049C48.6624 83.9604 45.9413 86.6815 42.5858 86.6815H18.5508V74.2505H42.5858C45.9413 74.2505 48.6624 76.9715 48.6624 80.3271Z",
    fill: "white",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6385 80.4658C50.6385 82.5902 49.7767 84.5126 48.3846 85.9047C46.9925 87.2968 45.0701 88.1586 42.9456 88.1586H17.1587V86.6813H42.5858C45.9413 86.6813 48.6624 83.9602 48.6624 80.6047V80.3269C48.6624 76.9713 45.9413 74.2503 42.5858 74.2503H17.1587V72.7729H42.9456C47.1945 72.7729 50.6385 76.2169 50.6385 80.4658Z",
    fill: "#CDD0D5",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0935 58.8555V71.2834H61.0585C57.703 71.2834 54.9819 68.5655 54.9819 65.2099V64.929C54.9819 61.5734 57.703 58.8555 61.0585 58.8555L85.0935 58.8555Z",
    fill: "white",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9819 64.9285V65.2094C54.9819 68.5649 57.703 71.2829 61.0586 71.2829H86.4856V72.7602H60.6987C58.5742 72.7602 56.6518 71.8984 55.2597 70.5063C53.8676 69.1142 53.0059 67.1918 53.0059 65.0674C53.0059 60.8185 56.4498 57.3745 60.6987 57.3745H86.4856V58.855H61.0586C57.703 58.855 54.9819 61.5729 54.9819 64.9285Z",
    fill: "#CDD0D5",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7564 91.8233L32.4006 88.6481L29.0449 91.8233V81.5923H35.7564V91.8233Z",
    fill: "#CDD0D5",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8241 51.875C14.8241 51.875 10.4458 51.8899 10.4458 56.2533C10.4458 51.8899 6.06738 51.875 6.06738 51.875C6.06738 51.875 10.4458 51.8601 10.4458 47.4966C10.4458 51.8601 14.8241 51.875 14.8241 51.875Z",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4457 9.55077C64.4457 9.55077 60.0673 9.56565 60.0673 13.9291C60.0673 9.56565 55.689 9.55077 55.689 9.55077C55.689 9.55077 60.0673 9.53583 60.0673 5.17236C60.0673 9.53583 64.4457 9.55077 64.4457 9.55077Z",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7856,
    y: 21.3418,
    width: 56.0737,
    height: 36.0331,
    rx: 3.81443,
    fill: "white",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.93,
    cy: 35.0823,
    r: 7.48027,
    fill: "white",
    stroke: "#868C98",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.126 40.8159C31.3519 38.3613 33.4166 36.4392 35.9301 36.4392C38.4437 36.4392 40.5083 38.3613 40.7343 40.8158C39.4347 41.9059 37.759 42.5623 35.9301 42.5623C34.1012 42.5623 32.4256 41.9059 31.126 40.8159ZM38.1754 33.6316C38.1754 34.8406 37.1953 35.8208 35.9862 35.8208C34.7772 35.8208 33.7971 34.8406 33.7971 33.6316C33.7971 32.4225 34.7772 31.4424 35.9862 31.4424C37.1953 31.4424 38.1754 32.4225 38.1754 33.6316Z",
    fill: "#868C98"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.126 40.8159L30.6281 40.7701C30.6131 40.9334 30.679 41.0936 30.8047 41.199L31.126 40.8159ZM40.7343 40.8158L41.0556 41.1989C41.1812 41.0936 41.2472 40.9333 41.2322 40.77L40.7343 40.8158ZM35.9301 35.9392C33.1558 35.9392 30.8775 38.0606 30.6281 40.7701L31.6239 40.8617C31.8264 38.6621 33.6773 36.9392 35.9301 36.9392V35.9392ZM41.2322 40.77C40.9827 38.0605 38.7044 35.9392 35.9301 35.9392V36.9392C38.1829 36.9392 40.0338 38.662 40.2364 40.8617L41.2322 40.77ZM40.413 40.4328C39.2 41.4501 37.6372 42.0623 35.9301 42.0623V43.0623C37.8809 43.0623 39.6693 42.3617 41.0556 41.1989L40.413 40.4328ZM35.9301 42.0623C34.223 42.0623 32.6602 41.4501 31.4473 40.4328L30.8047 41.199C32.1909 42.3617 33.9794 43.0623 35.9301 43.0623V42.0623ZM35.9862 36.3208C37.4714 36.3208 38.6754 35.1168 38.6754 33.6316H37.6754C37.6754 34.5645 36.9192 35.3208 35.9862 35.3208V36.3208ZM33.2971 33.6316C33.2971 35.1168 34.501 36.3208 35.9862 36.3208V35.3208C35.0533 35.3208 34.2971 34.5645 34.2971 33.6316H33.2971ZM35.9862 30.9424C34.501 30.9424 33.2971 32.1464 33.2971 33.6316H34.2971C34.2971 32.6987 35.0533 31.9424 35.9862 31.9424V30.9424ZM38.6754 33.6316C38.6754 32.1464 37.4714 30.9424 35.9862 30.9424V31.9424C36.9192 31.9424 37.6754 32.6987 37.6754 33.6316H38.6754Z",
    fill: "#868C98"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.2051,
    y: 30.1313,
    width: 24.4764,
    height: 2.93413,
    rx: 0.762887,
    fill: "#E2E4E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5295,
    y: 46.7173,
    width: 24.4764,
    height: 2.93412,
    rx: 0.762887,
    fill: "#E2E4E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 47.2051,
    y: 36.1812,
    width: 24.4764,
    height: 2.93412,
    rx: 0.762887,
    fill: "#E2E4E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60.699,
    y: 26.0063,
    width: 31.7948,
    height: 25.7855,
    rx: 3.81443,
    fill: "#E2E4E9",
    stroke: "#868C98",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7772 34.5452L70.145 36.8974L67.7092 39.3494C67.4608 39.5994 67.4622 40.0035 67.7122 40.2519C67.9623 40.5002 68.3663 40.4989 68.6147 40.2489L71.5002 37.3442C71.7486 37.0941 71.7472 36.6901 71.4972 36.4417L68.6766 33.6398C68.4266 33.3914 68.0226 33.3927 67.7742 33.6428C67.5258 33.8928 67.5271 34.2969 67.7772 34.5452Z",
    fill: "#868C98"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.267 33.5845L82.4651 36.4051C82.3466 36.5243 82.2791 36.6889 82.2797 36.857C82.2802 37.025 82.3489 37.1891 82.4681 37.3076L85.3728 40.1931C85.6228 40.4415 86.0269 40.4401 86.2752 40.1901C86.5236 39.9401 86.5223 39.536 86.2723 39.2876L83.8203 36.8519L86.1725 34.484C86.4209 34.234 86.4195 33.8299 86.1695 33.5816C85.9195 33.3332 85.5154 33.3345 85.267 33.5845Z",
    fill: "#868C98"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4627 45.1363L81.5657 45.1061C81.9182 45.105 82.2029 44.8183 82.2018 44.4659C82.2006 44.1134 81.9139 43.8287 81.5615 43.8299L72.4585 43.86C72.106 43.8612 71.8213 44.1478 71.8224 44.5003C71.8236 44.8527 72.1103 45.1375 72.4627 45.1363Z",
    fill: "#868C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotification);
export default __webpack_public_path__ + "static/media/Empty-notification.ae15d2f2ca975b93134ae7dd4457cc94.svg";
export { ForwardRef as ReactComponent };